export class LaporanKepesantrenan {
  constructor(
    public id: number,
    public judulPelatihan: string,
    public namaLengkap: string,
    public nipBaru: string,
    public nik: string,
    public isPesantren: number,
    public namaPesantren: string | null,
    public nsp: string | null,
    public alamat: string | null,
    public namaProvinsi: string | null,
    public namaKabupaten: string | null,
    public namaKecamatan: string | null,
    public peran: string | null,
    public tahunBergabung: string | null,
    public statusMukim: number | null,
  ) {}
}
